import { render, staticRenderFns } from "./GameZone.vue?vue&type=template&id=4f3bc31e&scoped=true&"
import script from "./GameZone.vue?vue&type=script&lang=js&"
export * from "./GameZone.vue?vue&type=script&lang=js&"
import style0 from "./GameZone.vue?vue&type=style&index=0&id=4f3bc31e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3bc31e",
  null
  
)

export default component.exports